/*eslint complexity: off*/
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import moment from 'moment';
import dig from 'object-dig';
import FaceIcon from '@material-ui/icons/Face';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import Chip from '@material-ui/core/Chip';
import LinkMaterial from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import CircularProgress from '@material-ui/core/CircularProgress';

import Paper from '~/components/Paper';
import Button from '~/components/Button';
import GridItem from '~/components/GridItem';
import InputShow from '~/components/InputShow';
import ModalDelete from '~/components/ModalDelete';
import PaperButtons from '~/components/PaperButtons';
import GridContainer from '~/components/GridContainer';
import ChipItem from '~/components/Chip';
import MedicalAppointmentsRecord from '~/records/MedicalAppointmentsRecord';
import { historyPropType } from '~/config/routerPropTypes';
import {
  medicalAppointments,
  showPerson,
  editMedicalAppointments,
} from '~/config/routes';
import Request from '~/providers/Request';
import Context from './context';
import Activities from '~/components/Activities';
import isBlank from '~/utils/isBlank';
import Storage from '~/providers/Storage';
import { USERS_DOWNLOAD_APPOINTMENTS } from '~/config/constants';
import isPresent from '~/utils/isPresent';
import { AbilityContext } from '~/contexts/Can';

const useStyles = makeStyles(() => ({
  circularProgress: {
    color: 'grey',
    marginRight: '10px',
  },
}));

const attrName = (attr) => MedicalAppointmentsRecord.hummanAttributeName(attr);

function ShowMedicalAppointments({ history }) {
  const { id } = history.location.route.getParams();
  const { records, addRecords } = useContext(Context);
  const [record, setRecord] = useState(new MedicalAppointmentsRecord());
  const [priority, setPriority] = useState([]);
  const [status, setStatus] = useState([]);
  const [integration_status, setIntegrationStatus] = useState([]);
  const [integration_status_id, setIntegrationStatusId] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(!records || !records[id]);
  const [modal, setModal] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [permissionToDownload, setPermissionToDownload] = useState(false);
  const [recordArray, setRecordArray] = useState({ attendent: [], doctor: [] });
  const [itemDwn, setItemDwn] = useState('');
  const classes = useStyles();
  const ability = useContext(AbilityContext);

  const priorityArray = {
    low: t('medicalAppointments.priority.low'),
    medium: t('medicalAppointments.priority.medium'),
    high: t('medicalAppointments.priority.high'),
  };

  const statusArray = {
    new: t('medicalAppointments.status.new'),
    pre_appointment: t('medicalAppointments.status.pre_appointment'),
    wait_room: t('medicalAppointments.status.wait_room'),
    wait_room_scheduled: t('medicalAppointments.status.wait_room_scheduled'),
    ongoing: t('medicalAppointments.status.ongoing'),
    on_schedule: t('medicalAppointments.status.on_schedule'),
    on_approval: t('medicalAppointments.status.on_approval'),
    finished: t('medicalAppointments.status.finished'),
    in_consultation: t('medicalAppointments.status.in_consultation'),
    pre_appointment_finished: t(
      'medicalAppointments.status.pre_appointment_finished'
    ),
    no_show: t('medicalAppointments.status.no_show'),
    canceled: t('medicalAppointments.status.canceled'),
  };

  const priorityColor = {
    low: '#03D100',
    medium: '#FF6B00',
    high: '#E00023',
  };

  const statusColor = {
    new: '#AC92EA',
    pre_appointment: '#AC92EA',
    wait_room: '#AC92EA',
    wait_room_scheduled: '#2182F6',
    on_approval: '#AC92EA',
    on_schedule: '#AC92EA',
    in_consultation: '#AC92EA',
    ongoing: '#F9D159',
    finished: '#03D100',
    pre_appointment_finished: '#AC92EA',
    no_show: '#999999',
    canceled: '#999999',
  };

  const integrationStatusColor = ['#999999', '#03D100', '#E00023', '#999999'];
  const integrationStatusText = [
    'Não integrado',
    'Sucesso',
    'Falha',
    'Não integrado',
  ];

  const trExtra = (extra) => t(`medicalAppointments.extras.${extra}`);

  useEffect(() => {
    async function fetchData(id) {
      if (records && records[id]) {
        record.updateAttributes(records[id]);
      }

      setLoading(true);
      Request.get(`/admin/medical_appointment/${id}`, {})
        .then((response) => {
          setLoading(false);
          addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
          setRecord(record.updateAttributes(response.data));
          setPriority(priorityArray[response.data.priority]);
          setStatus(
            response.data.status === 'no_show' && response.data.no_show_by
              ? `${statusArray.no_show} (${t(
                  `medicalAppointments.no_show_by.${response.data.no_show_by}`
                ).toLowerCase()})`
              : statusArray[response.data.status]
          );
          setIntegrationStatus(response.data.integration_status);
          setIntegrationStatusId(response.data.integration_id_status);
        })
        .catch((e) => {
          console.error(e);
          setLoading(false);
        });
    }
    fetchData(id);
    formatRecord();
    verifyPermissionsDownload();
  }, []);

  useEffect(() => {
    // Socket.onConnect((ws) => {
    //   const _wsUser = ws.subscriptionOrSubscribe(`user:${user.uuid}`);
    //   _wsUser.on('message', async ({ type }) => {
    //     if (type === 'convertFileDone') {
    //       console.log('\n\n', 'type socket:', type, '\n\n');
    //       await handleAppointmentFile(itemDwn);
    //     }
    //   });
    // });
    // Socket.connect().catch(() => {});
  }, []);

  useEffect(() => {
    formatRecord();
  }, [record]);

  async function formatRecord() {
    try {
      const recordData = JSON.parse(record.get('record_filename'));
      setRecordArray(recordData);
    } catch (err) {
      setRecordArray({
        attendent: [],
        doctor: [{ m3u8: record.get('record_filename') }],
      });
    }
  }

  async function verifyPermissionsDownload() {
    const userIdsDownload = USERS_DOWNLOAD_APPOINTMENTS;
    const userLoggedObj = await Storage.getItem(Storage.userKey);
    if (isBlank(userIdsDownload) || isBlank(userLoggedObj)) return;
    const arrIds = [];
    userIdsDownload
      .split(',')
      .forEach((user_id) => arrIds.push(parseInt(user_id.trim())));
    if (arrIds.indexOf(parseInt(userLoggedObj.id)) !== -1)
      setPermissionToDownload(true);
  }

  async function handleDelete() {
    setLoading(true);
    Request.del(`/admin/medical_appointment/${id}`)
      .then(() => {
        toast.success(t('delete-toast-success'));
        history.push(medicalAppointments.spec);
      })
      .catch(() => {
        setLoading(false);
        toast.error(t('delete-toast-fail'));
      });
    setModal(false);
  }

  async function handleAppointmentFile(m3u8) {
    setItemDwn(m3u8);
    setDownloading(true);
    Request.get(
      `/admin/appointment_file/${id}/${m3u8}`,
      {},
      { normalizeJSON: false }
    )
      .then((response) => {
        // if (isBlank(response.url)) {
        //   console.info('Waiting for convertion ...');
        // } else {

        setDownloading(false);
        setItemDwn('');
        window.open(response.url);

        // }
      })
      .catch((e) => {
        setDownloading(false);
        setItemDwn('');
        console.error(e);
      });
  }

  return (
    <Paper
      Icon={LocalHospitalIcon}
      iconColor="blue"
      title={t('medicalAppointments.defSingular')}
      loading={loading}
      actions={
        <PaperButtons
          id={id}
          setModal={
            ability.can('delete', 'MedicalAppointments') ? setModal : null
          }
          backRoute={medicalAppointments}
          editRoute={
            ability.can('edit', 'MedicalAppointments')
              ? editMedicalAppointments
              : null
          }
        />
      }
    >
      <GridContainer>
        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputLabel shrink>{attrName('user')}</InputLabel>
          <Chip
            icon={<FaceIcon />}
            label={dig(record.get('user'), 'name')}
            component={LinkMaterial}
            href={showPerson.reverse({ id: dig(record.get('user'), 'id') })}
            style={{ cursor: 'pointer' }}
            target="_blank"
            color="primary"
            variant="outlined"
            onDelete={() => {}}
            deleteIcon={<OpenInNewIcon />}
          />
        </GridItem>
        <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
          <InputShow
            value={record.get('user')}
            digObject={['cell_phone']}
            type={'object'}
            label={attrName('user_phone')}
          />
        </GridItem>
        <GridItem xs={12} sm={3} md={3} lg={3} xl={3}>
          <InputShow
            value={record.get('user')}
            digObject={['email']}
            type={'object'}
            label={attrName('user_email')}
          />
        </GridItem>
        <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
          {recordArray &&
          recordArray.attendent &&
          recordArray.attendent.length > 0 ? (
            <>
              {recordArray.attendent.map((item, j) => {
                return (
                  <Button
                    key={j}
                    style={{ marginTop: 20 }}
                    disabled={downloading || !permissionToDownload}
                    onClick={() => handleAppointmentFile(item.m3u8)}
                  >
                    {downloading && itemDwn === item.m3u8 ? (
                      <>
                        <CircularProgress
                          size={20}
                          className={classes.circularProgress}
                        />
                        {trExtra(t('download_record_attendent_wait'))}
                      </>
                    ) : (
                      <>
                        <SaveAltIcon style={{ marginRight: '10px' }} />
                        {trExtra(t('download_record_attendent'))}
                      </>
                    )}
                  </Button>
                );
              })}
            </>
          ) : (
            <h5 style={{ marginTop: '40px' }}>
              {' '}
              {trExtra('attendent_not_consulted').toUpperCase()}{' '}
            </h5>
          )}
        </GridItem>
        <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
          {recordArray &&
          recordArray.doctor &&
          recordArray.doctor.length > 0 ? (
            <>
              {recordArray.doctor.map((item, j) => {
                return (
                  <Button
                    key={j}
                    style={{ marginTop: 20 }}
                    disabled={downloading || !permissionToDownload}
                    onClick={() => handleAppointmentFile(item.m3u8)}
                  >
                    {downloading && itemDwn === item.m3u8 ? (
                      <>
                        <CircularProgress
                          size={20}
                          className={classes.circularProgress}
                        />
                        {trExtra(t('download_record_doctor_wait'))}
                      </>
                    ) : (
                      <>
                        <SaveAltIcon style={{ marginRight: '10px' }} />
                        {trExtra(t('download_record_doctor'))}
                      </>
                    )}
                  </Button>
                );
              })}
            </>
          ) : (
            <h5 style={{ marginTop: '40px' }}>
              {' '}
              {trExtra('doctor_not_consulted').toUpperCase()}{' '}
            </h5>
          )}
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            value={record.get('doctor')}
            digObject={['name']}
            type={'object'}
            label={attrName('doctor')}
          />
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            value={record.get('attendant')}
            digObject={['name']}
            type={'object'}
            label={attrName('attendant')}
          />
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            value={
              isPresent(record.get('created_at'))
                ? moment(record.get('created_at')).format('LLL')
                : ''
            }
            label={attrName('created_at')}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            value={record.get('category')}
            digObject={['name']}
            type={'object'}
            label={attrName('category')}
          />
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            value={record.get('specialty')}
            digObject={['name']}
            type={'object'}
            label={attrName('specialty')}
          />
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputShow
            value={
              isPresent(record.get('schedule_appointment_at'))
                ? moment(record.get('schedule_appointment_at')).format('LLL')
                : ''
            }
            label={attrName('appointment_at')}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputLabel shrink>{attrName('priority')}</InputLabel>
          {record.get('priority') && (
            <ChipItem
              label={priority}
              colorHex={priorityColor[record.get('priority')]}
            />
          )}
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputLabel shrink>{attrName('status')}</InputLabel>
          <ChipItem
            label={status}
            colorHex={statusColor[record.get('status')]}
          />
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputLabel shrink>{attrName('integration_status_sus')}</InputLabel>
          <ChipItem
            label={
              integration_status === null
                ? 'Não integrado'
                : integrationStatusText[integration_status_id]
            }
            colorHex={
              integration_status_id === null
                ? integrationStatusColor[0]
                : integrationStatusColor[integration_status_id]
            }
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          <InputShow
            value={record.get('notes')}
            label={attrName('notes')}
            InputProps={{
              multiline: true,
              rows: '6',
            }}
          />
        </GridItem>
      </GridContainer>

      <Activities
        data={record.get('activities')}
        keys={['user_name', 'info', 'platform', 'created_at']}
      />

      <ModalDelete
        modal={modal}
        onClose={() => {
          setModal(false);
        }}
        name={record.get('name')}
        id={record.get('id')}
        deleteAction={handleDelete}
      />
    </Paper>
  );
}

ShowMedicalAppointments.propTypes = {
  history: historyPropType,
};

export default ShowMedicalAppointments;
